import React from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import styled from 'styled-components';

import SideNavigationBar from 'components/common/SideNavigationBar';
import SideLink from 'components/common/SideLink';
import Backlink from 'components/common/Backlink';

import TabBar from '@joinforma/ui/components/TabBar';
import TabItem from '@joinforma/ui/components/TabItem';
import { ScreenWidth } from '@joinforma/ui/constants/breakpoints';

import { HistoryRoutes } from 'utils/routeGenerator';

const Container = styled.div`
  padding: 40px 20px;
  max-width: 1140px;
  margin: 0 auto;
`;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: ${ScreenWidth.TABLET_PORTRAIT}) {
    flex-direction: row;
    justify-content: center;
  }
`;

const NavbarContainer = styled.div`
  width: 186px;
  margin-right: 100px;
  display: none;
  @media (min-width: ${ScreenWidth.TABLET_PORTRAIT}) {
    display: block;
  }
`;

const MobileTabContainer = styled.div`
  margin-bottom: 40px;
  @media (min-width: ${ScreenWidth.TABLET_PORTRAIT}) {
    display: none;
  }
`;

const ProfileLayout = ({ children }: { children?: React.ReactNode }) => {
  const location = useLocation();

  return (
    <Container>
      <PageContainer>
        <MobileTabContainer>
          <Backlink />
          <TabBar>
            <TabItem
              active={location.pathname.includes(HistoryRoutes.orderList())}
              to={HistoryRoutes.orderList()}
            >
              Orders
            </TabItem>
            <TabItem
              active={location.pathname.includes(
                HistoryRoutes.subscriptionList()
              )}
              to={HistoryRoutes.subscriptionList()}
            >
              Subscriptions
            </TabItem>
          </TabBar>
        </MobileTabContainer>
        <NavbarContainer>
          <SideNavigationBar header="History">
            <SideLink route={HistoryRoutes.orderList()}>Order history</SideLink>
            <SideLink route={HistoryRoutes.subscriptionList()}>
              Subscriptions
            </SideLink>
          </SideNavigationBar>
        </NavbarContainer>
        {children ?? <Outlet />}
      </PageContainer>
    </Container>
  );
};

export default ProfileLayout;
